import React, { useState } from 'react'
import {
  Link as MuiLink,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../../messages'
import DeleteDialog from '../../BitubeProductSummary/DeleteDialog'
import { fastDuplexOligosRoute, useRouter } from '@src/routes'
import { biTubeConfigContext } from '../../BiTube'
import ValidationErrors from '../../../../validations/ValidationErrors'
import {
  useSessionFieldsMutation,
  useBiTubePriceCallMutation,
  useBitubeTotalValidationMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import {
  BitubeProperties,
  BiTubeProduct,
  ReviewButtons,
  ActiveLinkType,
} from '../../enum'
import { EMPTY_REVIEW_OBJ } from '../../EmptySession'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import styles from '@src/routes/Configurators/utils/styles'
import OligoNameWarning from '@src/routes/Configurators/validations/oligoNameWarning'
import { getOverhangDisplayValue } from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(4, 5),
      marginBottom: theme.spacing(4),
      borderRadius: 0,
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    table: {
      backgroundColor: 'white',
    },
    clearButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(3, 0),
    },
    dFlex: {
      display: 'flex',
    },
    dFlexForZHLang: {
      display: 'flex',
      paddingRight: theme.spacing(4.25),
    },
    cardContent: {
      padding: theme.spacing(0),
    },
    deleteMargin: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(3),
    },
    label: {
      fontWeight: 'bold',
    },
    title: {
      backgroundColor: theme.palette.rich.red,
      color: 'white',
      fontWeight: 'bold',
      paddingBottom: '0px',
    },
    deleteButton: {
      padding: theme.spacing(0),
    },
    deleteAllText: {
      fontSize: theme.typography.pxToRem(16),
      padding: theme.spacing(1),
    },
    sequenceInfo: {
      fontSize: theme.typography.pxToRem(16),
    },
    alignRight: {
      textAlign: 'right',
    },
    rootRow: {
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    seqWordWrap: {
      width: 250,
      wordBreak: 'break-all',
    },
    amountWidth: {
      width: 130,
      wordBreak: 'break-all',
    },
    nameWidth: {
      width: theme.spacing(45),
      wordBreak: 'break-all',
      marginBottom: theme.spacing(3),
      cursor: 'pointer',
    },
    delPopup: {
      height: 0,
    },
    sequenceProperties: {
      width: '31%',
      '& + td': {
        paddingLeft: theme.spacing(1),
      },
      labelRoot: {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.grey[500],
      },
      activeLabel: {},
    },
    pt20: {
      paddingTop: theme.spacing(5),
    },
    errorRow: {
      '& th': {
        borderLeft: `8px solid ${theme.palette.rich.red}`,
        borderBottom: '0 none',
        padding: theme.spacing(2, 7, 2, 2),
      },
      '& td': {
        borderBottom: '0 none',
        padding: theme.spacing(0),
      },
    },
    successRow: {
      '& th': {
        borderBottom: '0 none',
        padding: theme.spacing(2, 7, 2, 2),
      },
      '& td': {
        borderBottom: '0 none',
        padding: theme.spacing(0),
      },
    },
    errorMsgRow: {
      padding: '2px',
      paddingLeft: '40px',
    },
    errorText: {
      color: theme.palette.error.main,
      display: 'inline-block',
      '& + div': {
        display: 'inline-block',
      },
    },
    topRow: {
      display: 'table',
      width: '100%',
    },
    topRowCell: {
      display: 'table-cell',
    },
    closeImg: {
      cursor: 'pointer',
      float: 'right',
      marginTop: '2px',
      width: '25px',
    },
    resetBorderBottom: {
      borderBottom: '0 none',
      padding: '0px',
    },
    name: {
      color: '#07a',
      fontWeight: 'bold',
    },
    buttonPadding: {
      paddingTop: theme.spacing(5),
    },
    tableContainer: {
      overflow: 'auto',
      maxHeight: theme.spacing(140),
    },
    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },
    override: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(-3),
    },
    margin: {
      marginTop: theme.spacing(-3),
    },
  }
})

export interface Data {
  id: number
  name: string
  base: string
  price: string
  scale: string
  purification: string
}

let data

export function performDelete(obj) {
  const array = data
  const index = array.indexOf(obj)
  if (index !== -1) {
    array.splice(index, 1)
    data = [...array]
  }
}

const ReviewDialog = (props) => {
  // This param is use to set CSS
  const classes = useStyles()
  const GlobalCSS = styles()
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const [delItem, setDelItem] = useState()
  const [delType, setDelType] = useState('')
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [isErrorMsg, setIsErrorMsg] = useState(false)
  const [open, setOpen] = useState(false)
  const [scrollBar, setScrollBar] = useState(false)
  const [isOverride, setIsOverride] = React.useState<any>(false)
  const [sessionFields] = useSessionFieldsMutation()
  const [biTubePriceCall] = useBiTubePriceCallMutation()
  const [bitubeTotalValidation] = useBitubeTotalValidationMutation()
  const router = useRouter()
  const intl = useIntl()
  const [isNameWarning, setIsNameWarning] = React.useState(false)
  const maxItems = BitubeProperties.MaximumOligosAllowed
  const { productDetails, setItemDetails } = props
  const sequencePath = `${fastDuplexOligosRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`
  const orderPath = `${fastDuplexOligosRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.ConfirmOrder}`
  const { sessionData, OligoIndex, countryCode, isSessionLoaded } = bitubeState
  const multiplePath = `${fastDuplexOligosRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.MultipleEntry}`
  const [errorMsg, setErrorMsg] = useState('')
  const sessionDataToSession = async (obj) => {
    await sessionFields({
      variables: { input: obj, productInput: productDetails },
    })
  }

  const checkListError = (item) => {
    const sequenceValidation: string[] = []
    const { listError } = item
    if (
      listError &&
      listError?.length !== 0 &&
      !(
        listError?.length === 1 &&
        listError[0]?.key === BitubeProperties.ReviewError
      )
    ) {
      listError.forEach((data) => {
        const { key, value } = data

        if (
          key &&
          value &&
          key === messages.CONF_REVIEW_ERROR_MSG.defaultMessage
        ) {
          sequenceValidation.push(value)
        }
      })
    }
    return sequenceValidation
  }
  // This method is use to perform delete and delete all operations
  const deleteOligoItem = (item, type) => {
    let isDeleteAll = false
    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (OligoIndex !== 0) {
        const newIndex = OligoIndex - 1
        const array = [...bitubeState.sessionData]
        const index = array.indexOf(item)
        if (index !== -1) {
          array.splice(index, 1)
        }

        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'DELETE_LAST_OLIGO',
          data: bitubeState.deleteLastOligo + 1,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: array,
        })
        if (array.length <= 5) {
          setScrollBar(false)
        }
        sessionDataToSession(array)
      } else {
        isDeleteAll = true
      }
    } else if (type === 'All') {
      sessionData[0].applyToAll = false
      isDeleteAll = true
    }

    if (isDeleteAll) {
      biTubeDispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'DELETE_LAST_OLIGO',
        data: bitubeState.deleteLastOligo + 1,
      })
      biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: true })
      sessionDataToSession([])
      router.push(sequencePath)
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [EMPTY_REVIEW_OBJ],
      })
      biTubeDispatch({ type: 'IS_BULK_REVIEW', data: false })
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...bitubeState.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          isOverridden: false,
          format: '',
          concentration: '',
          tubes: '1',
          customerOverhang: '',
          antisenceName: '',
          antisenceSequence: '',
          customerAntisenseOverHang: '',
          countryCode: countryCode,
          autoGenerateOligo: false,
          senseNameCheck: false,
        },
      })
      biTubeDispatch({ type: 'IS_DELETE_ALL', data: true })
    }
    biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })

    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    if (
      errorMsg.includes(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
    ) {
      setErrorMsg('')
      let isInvalidData = true
      sessionData.forEach((item) => {
        if (item.listError.length > 0 && isInvalidData) {
          setErrorMsg(
            intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
          )
          isInvalidData = false
        }
      })
    }
  }

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelType('Selected')
    setDelItem(item)
  }

  const handlePrevious = () => {
    biTubeDispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: 0,
    })
    biTubeDispatch({ type: 'IS_BULK_REVIEW', data: false })
    biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: false })
    router.push(multiplePath)

    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...bitubeState.errorData,
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: '',
        isOverridden: false,
        concentration: '',
        tubes: '1',
        countryCode: countryCode,
      },
    })
    biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })

    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    window.scrollTo(0, 0)
  }

  const callTotalValidation = async (num) => {
    const response: any = await biTubePriceCall({
      variables: { product: productDetails },
    })
    if (response.data) {
      biTubeDispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: response.data.biTubePriceCall,
      })
      let flag = false
      setItemDetails(response.data.biTubePriceCall)
      const allError: any[] = []
      if (
        response.data.biTubePriceCall &&
        response.data.biTubePriceCall.length > 0
      ) {
        response.data.biTubePriceCall.forEach((item, index) => {
          if (item.listErrors && item.listErrors.length !== 0) {
            flag = true
            item.listErrors.forEach((err) => {
              delete err.__typename
              allError.push(err)
            })
            if (sessionData.length > index) {
              sessionData[index].listError = item.listErrors
            }
          }
          if (sessionData.length > index) {
            sessionData[index].price = item.price
            sessionData[index].currencySymbol = item.currencySymbol
            sessionData[index].currency = item.currency
          }
          //update the circuit breaker warning if priceHeaderError in not null
          if (
            item.priceHeaderError !== null &&
            item.priceHeaderError.length !== 0
          ) {
            biTubeDispatch({ type: 'UPDATE_CIRCUIT_BREAK', data: true })
          } else {
            biTubeDispatch({ type: 'UPDATE_CIRCUIT_BREAK', data: false })
          }
        })
      } else {
        // if blank array is returned there is issue in priceCall, stay in the same page
        flag = true
      }
      if (!allError.length) {
        setOpen(false)
        setIsErrorMsg(false)
        setErrorMsg('')
      } else {
        setOpen(true)
        setIsErrorMsg(true)
        setErrorMsg(
          intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
        )
      }
      if (!flag) {
        biTubeDispatch({ type: 'IS_BULK_REVIEW', data: false })
        if (num === 1) {
          biTubeDispatch({ type: 'SET_STEP_NO', data: 1 })
          biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: true })
          biTubeDispatch({ type: 'ON_CONTINUE_BUTTON_PRICECALL', data: true })
          biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: false })
          router.push(orderPath)
        } else {
          biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
          biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
          biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
          biTubeDispatch({
            type: 'ADD_NEW_OLIGO',
            data: bitubeState.oligoCount + 1,
          })
          biTubeDispatch({
            type: 'ADD_NEW_DUPLEX',
            data: true,
          })
          biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: false })
          router.push(sequencePath)
        }
      }
      window.scrollTo(0, 0)
    }
  }

  React.useEffect(() => {
    window.scrollTo(0, 0)
    if (bitubeState.sessionData.length > 5) {
      setScrollBar(true)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleContinue = () => {
    callTotalValidation(1)
  }

  const handleAddDuplex = () => {
    if (sessionData.length < BitubeProperties.MaximumOligosAllowed) {
      biTubeDispatch({ type: 'SET_ERROR_ICON_ON_PAGELOAD', data: false })
      callTotalValidation(2)
    } else {
      setErrorMsg(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
      window.scrollTo(0, 0)
    }
  }
  const setErrorData = (index) => {
    return {
      name: sessionData[index].name,
      sequence: sessionData[index].sequence,
      scale: '',
      purification: sessionData[index].purification,
      fiveMod: '',
      threeMod: '',
      researcher: '',
      format: sessionData[index].format,
      concentration: sessionData[index].concentration,
      tubes: sessionData[index].tubes,
      countryCode: countryCode,
      isOverridden: sessionData[index].isOverridden,
      customerOverhang: sessionData[index].customerOverhang,
      antisenceName: sessionData[index].antisenceName,
      antisenceSequence: sessionData[index].antisenceSequence,
      customerAntisenseOverHang: sessionData[index].customerAntisenseOverHang,
      antisenceBaseCount: 0,
      amount: sessionData[index].amount,
      autoGenerateOligo: sessionData[index].autoGenerateOligo,
      senseNameCheck: sessionData[index].senseNameCheck,
    }
  }

  const displaySessionData = (index) => {
    biTubeDispatch({ type: 'SET_ERROR_ICON_ON_PAGELOAD', data: false })
    biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: false })
    router.push(sequencePath)
    biTubeDispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: index,
    })

    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: setErrorData(index),
    })
    biTubeDispatch({
      type: 'ITEM_VALIDATION',
      data: true,
    })
    biTubeDispatch({ type: 'HAS_REVIEW_ERROR', data: true })
  }

  React.useEffect(() => {
    if (isSessionLoaded) {
      let isListErrorRemaning = false
      sessionData.forEach((data) => {
        if (
          data.listError &&
          !isListErrorRemaning &&
          data.listError?.length !== 0 &&
          !(
            data.listError?.length === 1 &&
            (data.listError[0]?.key === BitubeProperties.ReviewError ||
              data.listError[0]?.key === '')
          )
        ) {
          isListErrorRemaning = true
        }
      })
      if (!isListErrorRemaning) {
        setErrorMsg('')
      } else {
        setErrorMsg(
          intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
        )
      }
      setIsErrorMsg(isListErrorRemaning)
      setOpen(isListErrorRemaning)
      if (sessionData[bitubeState.currentOligoIndex]) {
        setIsOverride(sessionData[bitubeState.currentOligoIndex].isOverridden)
      }
      if (sessionData && sessionData.length !== 0) {
        let warning = false
        sessionData.forEach((data) => {
          if (data.name && data.name.length > 18 && warning !== true) {
            warning = true
          }
        })
        setIsNameWarning(warning)
      }
      if (sessionData.length > 5) {
        setScrollBar(true)
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData, isSessionLoaded])

  const TotalValidation = async (isSaveTosession: boolean) => {
    const response: any = await bitubeTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    if (response.data && response.data.bitubeTotalValidation.length) {
      if (!response.data.bitubeTotalValidation[0].serverError) {
        const allError: any[] = []
        response.data.bitubeTotalValidation.forEach((item, index) => {
          const error: any[] = []
          item.listErrors.forEach((err) => {
            delete err.__typename
            error.push(err)
            allError.push(err)
          })
          sessionData[index].listError = error
        })
        if (!allError.length) {
          setOpen(false)
          setIsErrorMsg(false)
          setErrorMsg('')
        } else {
          setOpen(true)
          setIsErrorMsg(true)
          setErrorMsg(
            intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
          )
        }
      } else {
        biTubeDispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
        window.scrollTo(0, 0)
      }
    }
    if (isSaveTosession) {
      sessionDataToSession(sessionData)
    }
  }

  React.useEffect(() => {
    if (isSessionLoaded) {
      TotalValidation(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionLoaded])
  //handle override action
  const handleIsOverride = async (event) => {
    setIsOverride(event.target.checked)
    sessionData.forEach((item) => {
      item.isOverridden = event.target.checked
    })
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...bitubeState.errorData, isOverridden: event.target.checked },
    })
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    TotalValidation(true)
  }
  // This method is use to render data
  const renderData = () => {
    const result: any[] = []
    let errorMsg: string[] = []
    sessionData.forEach((item, index) => {
      errorMsg = checkListError(item)
      result.push(
        <TableRow
          key={index}
          className={
            errorMsg.length !== 0 ? classes.errorRow : classes.successRow
          }
        >
          <TableCell
            component="th"
            scope="row"
            className={clsx(classes.nameWidth)}
          >
            <MuiLink
              underline="hover"
              className={classes.name}
              onClick={() => displaySessionData(index)}
            >
              {productDetails.productType === BiTubeProduct.mirna ? (
                <strong>
                  {item.antisenceName?.length !== 0 ? item.antisenceName : '--'}
                </strong>
              ) : (
                <strong>{item.name?.length !== 0 ? item.name : '--'}</strong>
              )}
            </MuiLink>
          </TableCell>
          <TableCell
            align="left"
            padding="none"
            className={clsx(classes.seqWordWrap)}
          >
            {productDetails.productType === BiTubeProduct.mirna ? (
              <>
                {item.antisenceFiveMod !== BitubeProperties.None
                  ? item.antisenceFiveMod
                  : ''}{' '}
                {item.antisenceSequence?.length !== 0
                  ? item.antisenceSequence
                  : '--'}
                {item.customerAntisenseOverHang !== BitubeProperties.None
                  ? getOverhangDisplayValue(
                      bitubeState.specificationResponse,
                      item.customerAntisenseOverHang
                    )
                  : ''}
                {item.antisenceThreeMod !== BitubeProperties.None
                  ? item.antisenceThreeMod
                  : ''}
              </>
            ) : (
              <>
                {item.fiveMod !== BitubeProperties.None ? item.fiveMod : ''}{' '}
                {item.sequence?.length !== 0 ? item.sequence : '--'}
                {item.customerOverhang !== BitubeProperties.None
                  ? getOverhangDisplayValue(
                      bitubeState.specificationResponse,
                      item.customerOverhang
                    )
                  : ''}
                {item.threeMod !== BitubeProperties.None ? item.threeMod : ''}
              </>
            )}
          </TableCell>
          <TableCell align="center">
            {productDetails.productType === BiTubeProduct.mirna ? (
              <>
                {item.antisenceBaseCount !== 0 ? item.antisenceBaseCount : '--'}
              </>
            ) : (
              <>{item.baseCount !== 0 ? item.baseCount : '--'}</>
            )}
          </TableCell>
          <TableCell align="center" className={clsx(classes.amountWidth)}>
            {item.amount?.length !== 0 ? (
              <FormattedMessage
                {...checkValidKey(
                  messages[
                    `_PC_SPEC_${item.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                  ],
                  `_PC_SPEC_${item.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                )}
              />
            ) : (
              '--'
            )}
          </TableCell>
          <TableCell align="center">
            {item.purification?.length !== 0 ? (
              <FormattedMessage
                {...checkValidKey(
                  messages[`_PC_SPEC_${item.purification}`],
                  `_PC_SPEC_${item.purification}`
                )}
              />
            ) : (
              '--'
            )}
          </TableCell>
          <TableCell align="center">
            {item.tubes?.length !== 0 ? item.tubes : '--'}
          </TableCell>
          <TableCell align="right">
            <IconButton
              aria-label="delete"
              onClick={() => {
                handleDelete(item)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </TableCell>
        </TableRow>,
        <TableRow
          key={index}
          className={
            errorMsg.length !== 0 ? classes.errorRow : classes.successRow
          }
        >
          <TableCell
            component="th"
            scope="row"
            className={clsx(classes.nameWidth)}
          >
            <MuiLink
              underline="hover"
              className={classes.name}
              onClick={() => displaySessionData(index)}
            >
              {productDetails.productType === BiTubeProduct.mirna ? (
                <strong>{item.name?.length !== 0 ? item.name : '--'}</strong>
              ) : (
                <strong>
                  {item.antisenceName?.length !== 0 ? item.antisenceName : '--'}
                </strong>
              )}
            </MuiLink>
          </TableCell>
          <TableCell align="left" className={clsx(classes.seqWordWrap)}>
            {productDetails.productType === BiTubeProduct.mirna ? (
              <>
                {item.fiveMod !== BitubeProperties.None ? item.fiveMod : ''}{' '}
                {item.sequence?.length !== 0 ? item.sequence : '--'}
                {item.customerOverhang !== BitubeProperties.None
                  ? getOverhangDisplayValue(
                      bitubeState.specificationResponse,
                      item.customerOverhang
                    )
                  : ''}
                {item.threeMod !== BitubeProperties.None ? item.threeMod : ''}
              </>
            ) : (
              <>
                {item.antisenceFiveMod !== BitubeProperties.None
                  ? item.antisenceFiveMod
                  : ''}{' '}
                {item.antisenceSequence?.length !== 0
                  ? item.antisenceSequence
                  : '--'}
                {item.customerAntisenseOverHang !== BitubeProperties.None
                  ? getOverhangDisplayValue(
                      bitubeState.specificationResponse,
                      item.customerAntisenseOverHang
                    )
                  : ''}
                {item.antisenceThreeMod !== BitubeProperties.None
                  ? item.antisenceThreeMod
                  : ''}
              </>
            )}
          </TableCell>
          <TableCell align="center">
            {productDetails.productType === BiTubeProduct.mirna ? (
              <>{item.baseCount !== 0 ? item.baseCount : '--'}</>
            ) : (
              <>
                {item.antisenceBaseCount !== 0 ? item.antisenceBaseCount : '--'}
              </>
            )}
          </TableCell>
          <TableCell align="center" className={clsx(classes.amountWidth)}>
            {item.amount?.length !== 0 ? (
              <FormattedMessage
                {...checkValidKey(
                  messages[
                    `_PC_SPEC_${item.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                  ],
                  `_PC_SPEC_${item.amount}`.replace(/[^a-zA-Z0-9]/g, '_')
                )}
              />
            ) : (
              '--'
            )}
          </TableCell>
          <TableCell align="center">
            {item.purification?.length !== 0 ? (
              <FormattedMessage
                {...checkValidKey(
                  messages[`_PC_SPEC_${item.purification}`],
                  `_PC_SPEC_${item.purification}`
                )}
              />
            ) : (
              '--'
            )}
          </TableCell>
          <TableCell align="center">
            {item.tubes?.length !== 0 ? item.tubes : '--'}
          </TableCell>
        </TableRow>,
        <TableRow>
          <TableCell className={classes.errorMsgRow} colSpan={7}>
            {errorMsg.length !== 0 ? (
              <div>
                <div className={classes.errorText}>
                  <FormattedMessage {...messages.CONF_ERROR} />
                </div>
                <ValidationErrors errors={errorMsg} />
              </div>
            ) : (
              ''
            )}
          </TableCell>
        </TableRow>
      )
      return true
    })
    return result
  }

  return (
    <>
      {isErrorMsg ? (
        <ErrorAlert open={open} setOpen={setOpen} message={errorMsg} />
      ) : (
        ''
      )}
      {isNameWarning ? (
        <Grid className={GlobalCSS.warningBox}>
          <OligoNameWarning
            warning={intl.formatMessage(messages.CONF_OLIGO_NAME_WARNING)}
          />
        </Grid>
      ) : (
        ''
      )}
      <div className={classes.header}>
        <h3 className={classes.subHead}>
          <strong>
            <FormattedMessage {...messages.CONF_SEQUENCE_ENTRY} />
          </strong>
        </h3>
        <div className={scrollBar ? classes.dFlexForZHLang : classes.dFlex}>
          {productDetails.isCSRSupervisor ? (
            <FormControlLabel
              classes={{ label: classes.override }}
              control={
                <Checkbox
                  color="primary"
                  className={classes.margin}
                  value={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
                />
              }
              label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
              onChange={handleIsOverride}
              checked={isOverride}
            />
          ) : (
            ''
          )}
          <h4>
            <strong className={classes.deleteAllText}>
              <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
            </strong>
          </h4>
          <span className={classes.deleteMargin}>
            <IconButton
              aria-label="delete"
              className={classes.deleteButton}
              onClick={() => {
                setDelDialogOpen(true)
                setDelType('All')
                setDelItem(delItem)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </span>
        </div>
      </div>
      <div className={scrollBar ? classes.tableContainer : ''}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage {...messages.NAME} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                # <FormattedMessage {...messages.CONF_BASES} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_VIEWALL_AMOUNT} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                <FormattedMessage {...messages.CONF_PURIFICATION} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                # <FormattedMessage {...messages.CONF_VIEWALL_TUBES} />
              </TableCell>
              <TableCell align="left" className={classes.rootRow}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderData()}</TableBody>
        </Table>
      </div>
      <Grid container spacing={1} className={classes.buttonPadding}>
        <Grid item xs={8}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={handleAddDuplex}
          >
            {ReviewButtons.AddDuplex}
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={1}>
            <Grid item xs={7}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={handlePrevious}
              >
                {ReviewButtons.PrevPage}
              </Button>
            </Grid>
            <Grid item xs={5}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                onClick={handleContinue}
              >
                {ReviewButtons.Continue}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DeleteDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteOligoItem}
      />
    </>
  )
}

export default ReviewDialog
